/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type AccommodationUnitPattern = typeof AccommodationUnitPattern[keyof typeof AccommodationUnitPattern];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccommodationUnitPattern = {
  Single: 'Single',
  Double: 'Double',
  Triple: 'Triple',
  Quad: 'Quad',
} as const;
